<template>
  <div class="launchpack-delivery">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회">
      <div slot="custom_period" class="flex-align">
        <div class="flex-align" style="margin-right:12px;">
          <div v-for="(day, day_idx) in dayItems"
               class="unselect day-item"
               :class="{'selected': day.selected}"
               @click="selectDate(day)"
               :key="`day-${day_idx}`">{{ day.label }}</div>
        </div>
        <div style="align-items: center;">
          <admin-date-picker
            style="display: inline-block;margin-bottom:0"
            type="date"
            :data="filtered.start"
            @setDate="selectStart"></admin-date-picker>
        </div>
        <div style="display:inline-block;margin: 0 8px;font-size: 18px;color:#064160">&#126;</div>
        <div>
          <admin-date-picker
            style="display: inline-block;margin-bottom:0"
            type="date"
            :data="filtered.end"
            @setDate="selectEnd"></admin-date-picker>
        </div>
      </div>
    </admin-filter>

    <div class="flex">
      <div class="basic-tab" :class="{'tab-selected': selectedTab===0}" @click="selectedTab=0">품목별</div>
      <div class="basic-tab" :class="{'tab-selected': selectedTab===1}" @click="selectedTab=1">상품별</div>
    </div>
    <!-- 품목별 -->
    <order-table
      ref="orderTable"
      :field_list="tableData"
      :items="tableItems"
      :filtered="filtered"
      :allCount="allCount"
      :filteredCount="filteredCount"
      @check="clickCheckBox"
      :table_width="1000"
      @getData="getDataFromServer"
      @ordering="ordering"
      @selPageLength="selPageLength" v-if="selectedTab===0">
      <td slot="priority" slot-scope="props" v-if="props.item.priority">{{ props.item.priority }}</td>
      <td slot="name" slot-scope="props" style="text-align: left !important;">
        <div class="flex-align">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px"
               v-if="props.item.product.img"/>
          <div>
            <div>{{ props.item.product.name }}</div>
            <div style="color:#777777;font-size:12px;">{{ props.item.option_name }}</div>
          </div>
        </div>
      </td>
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>
      <td slot="order_count" slot-scope="props">{{ props.item.order_count }}</td>
      <td slot="refund_count" slot-scope="props">{{ props.item.refund_count }}</td>
      <td slot="sales_count" slot-scope="props">{{ props.item.sales_count }}</td>
      <td slot="sales_price" slot-scope="props">{{ props.item.sales_price | currency }}</td>
    </order-table>

    <!-- 상품별 -->
    <order-table
      ref="orderTable"
      :field_list="tableData"
      :items="tableItems"
      :filtered="filtered"
      :allCount="allCount"
      :filteredCount="filteredCount"
      @check="clickCheckBox"
      :table_width="1000"
      @getData="getDataFromServer"
      @ordering="ordering"
      @selPageLength="selPageLength" v-if="selectedTab===1">
      <td slot="priority" slot-scope="props" v-if="props.item.priority">{{ props.item.priority }}</td>
      <td slot="name" slot-scope="props" style="text-align: left !important;">
        <div class="flex-align">
          <img :src="props.item.img" style="width:35px;height:35px;margin-right:6px"
               v-if="props.item.img"/>
          <div>{{ props.item.name }}</div>
        </div>
      </td>
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>
      <td slot="order_count" slot-scope="props">{{ props.item.order_count }}</td>
      <td slot="refund_count" slot-scope="props">{{ props.item.refund_count }}</td>
      <td slot="sales_count" slot-scope="props">{{ props.item.sales_count }}</td>
      <td slot="sales_price" slot-scope="props">{{ props.item.sales_price | currency }}</td>
    </order-table>

  </div>
</template>

<script>
  import MartMixin from "@/mixins/MartMixin"
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import moment from "moment";

  export default {
    name: 'MartOrderStatisticsProduct',
    components: {LpAdmDropInput},
    mixins: [
      MartMixin
    ],
    data () {
      return {
        total_price: 0,
        refund_price: 0,
        dayItems: [{
          label:'오늘',
          selected: false
        },{
          label:'어제',
          selected: false
        },{
          label:'1주일',
          selected: true
        },{
          label:'1개월',
          selected: false
        },{
          label:'3개월',
          selected: false
        }]
      }
    },
    watch: {
      tableItems(n) {
        for(let i=0; i<this.tableItems.length; i++) {
          this.tableItems[i].priority = i + 1;
        }
      },
      selectedTab(n) {
        if (this.selectedTab === 0) {
          this.initializing('order_statistics_product_option', 'mart/order/statistics/product/option');
        }
        if (this.selectedTab === 1) {
          this.initializing('order_statistics_product', 'mart/order/statistics/product');
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      async init() {
        await this.initializing('order_statistics_product', 'mart/order/statistics/product');
      },
      async getDataFromServer() {
        await this.getData();
      },
      selectStart(res) {
        this.filtered.start = res;
        this.initDayItem();
        this.getDataFromServer();
      },
      selectEnd(res) {
        this.filtered.end = res
        this.initDayItem();
        this.getDataFromServer();
      },
      selectDate (day) {
        this.initDayItem();
        day.selected=true;
        let nowTime = moment();
        this.filtered.end = nowTime.format('YYYY-MM-DD');
        // item.end.value =
        // this.filtered[item.end.key

        switch(day.label) {
          case '오늘':
            this.filtered.start = this.filtered.end;
            break;
          case '어제':
            this.filtered.start = nowTime.subtract(1, 'days').format('YYYY-MM-DD');
            break;
          case '1주일':
            this.filtered.start = nowTime.subtract(1, 'week').format('YYYY-MM-DD');
            break;
          case '1개월':
            this.filtered.start = nowTime.subtract(1, 'months').format('YYYY-MM-DD');
            break;
          case '3개월':
            this.filtered.start = nowTime.subtract(3, 'months').format('YYYY-MM-DD');
            break;
        }
        this.filtered.page_num=1;
        this.getDataFromServer();
      },
      initDayItem() {
        this.dayItems.forEach(day => {
          day.selected = false;
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb

  .delivery-info
    position absolute
    left -170px
    top 38px
    background #eee
    z-index 10
    padding 8px
    width 240px

  .delivery-info
    display none

  .delivery-section:hover .delivery-info
    display block

  .sales-situation-box
    text-align center
    border 2px solid #ddd
    color #363636
    border-right 0

  .sales-situation-box:last-child
    border-right 2px solid #ddd

  .sales-situation-box > div:first-child
    border-bottom 2px solid #ddd

  .sales-situation-box > div
    padding 9.5px

  .sales-situation-box > div:last-child
    font-weight bold
    font-size 15px

  .day-item
    font-size 14px
    text-align center
    width 51px
    height 31px
    line-height 31px
    color #363636
    border 1px solid #dbdbdb
    border-radius 4px
    margin-right 2px

  .day-item.selected
    color $primary
    border 1px solid $primary
</style>
